import styled from "@emotion/styled";
import colors from "styles/colors";
export const StyledAiMenuComponent = styled.div`
  display: flex;
  gap: 0;

  .section-title {
    font-size: 1.25rem;
    line-height: 32px;
    margin-bottom: 12px;
    display: block;

  }

  .ai-products-section {
    display: flex;
    flex-direction: column;

    .products-container {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    .title-badge {
      padding: 2px 6px;
      background-color: #f0f0f0;
      border-radius: 4px;
      font-size: 0.625rem;
      font-weight: 500;
      color: ${colors.asphalt};
      white-space: nowrap;
    }
  }

  .ai-resources-section {
    display: flex;
    flex-direction: column;
    width: 200px;

    .resources-container {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
  }

  .ai-impact-section {
    display: flex;
    flex-direction: column;
    width: 320px;

    .impact-link {
      display: flex;
      flex-direction: column;
      text-decoration: none;
        
      .impact-image {
        width: 320px;
        height: 200px;
        object-fit: cover;
        display: block;
        border-radius: 8px;
      }

      .impact-text {
        display: flex;
        flex-direction: column;
        padding-top: 16px;
        gap: 12px;


          .impact-title {
          font-size: 0.875rem;
          font-weight: 600;
          color: black;
          margin-bottom: 4px;
        }

        .impact-link-text {
          font-size: 0.75rem;
          font-weight: 400;
          color: ${colors.mud};
          text-decoration: underline;
        }
      }
    }
  }
`;
